export const apiCreate = (): string => '/commercial/menuFoods/create'
export const apiList = (id?: string): string =>
  !id ? '/commercial/menufoods/' : `/commercial/menuFoods/view/${id}`
export const apiViewUpdate = (id: string): string =>
  `/commercial/menuFoods/viewUpdate/${id}`
export const apiUpdate = (id: string): string =>
  `/commercial/menuFoods/update/${id}`
export const apiDelete = (id: string): string =>
  `/commercial/menuFoods/delete/${id}`

export const apiListDishes = (): string => '/commercial/dishes'
export const apiListDishTypes = (): string => '/commercial/dishesTypes'

export const apiListInstitutions = (): string => '/commercial/institutions'

export const apiListInstitutionsOptions = (): string =>
  '/commercial/institutions/listOptions'

export const apiListMenuFoodTypes = (): string => '/commercial/menuFoodTypes'

export const apiCreateMenuFoodDishes = () => '/commercial/menuFoodDishes/create'

export const apiUpdateMenuFoodDishes = (id: string): string =>
  `/commercial/menuFoodDishes/update/${id}`

export const apiDeleteMenuFoodDishes = (
  menuFoodDishId: string,
  menuFoodId?: string
): string =>
  menuFoodId
    ? `/commercial/menuFoodDishes/delete/${menuFoodDishId}?menu_food_id=${menuFoodId}`
    : `/commercial/menuFoodDishes/delete/${menuFoodDishId}`

export const apiListMenuFoodTemplates = (id: string) =>
  `/commercial/menuFoodTemplates/listByMenuFoodId/${id}`

export const apiCreateMenuFoodTemplates = () =>
  '/commercial/menuFoodTemplates/create'

export const apiUpdateMenuFoodTemplates = (id: string): string =>
  `/commercial/menuFoodTemplates/update/${id}`

export const apiDeleteMenuFoodTemplates = (id: string): string =>
  `/commercial/menuFoodTemplates/delete/${id}`

export const apiDuplicateMenuFoodTemplates = (): string =>
  '/commercial/menuFoodTemplates/duplicateToMenuFood'

export const apiDuplicateAllMenuFoodTemplates = (): string =>
  '/commercial/menuFoodTemplates/duplicateAllToMenuFood'
